<template>
  <div class="min-h-screen bg-surface">
    <div class="max-w-3xl mx-auto px-4 py-12">
      <NuxtLink to="/auth" class="inline-flex items-center gap-1 text-primary mb-8 hover:underline">
        <span class="material-symbols-rounded" style="font-size: 18px;">arrow_back</span>
        Volver
      </NuxtLink>

      <h1 class="text-display-small font-bold text-on-surface mb-2">Política de Cookies</h1>
      <p class="text-body-medium text-on-surface-variant mb-8">Última actualización: 26 de marzo de 2026</p>

      <div class="prose prose-neutral max-w-none space-y-6 text-body-large text-on-surface/90 leading-relaxed">

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">1. ¿Qué son las cookies?</h2>
          <p>Las cookies son pequeños archivos de texto que los sitios web almacenan en tu dispositivo. Permiten recordar información sobre tu visita, como tus preferencias o el estado de tu sesión.</p>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">2. Cookies que utilizamos</h2>

          <div class="overflow-x-auto">
            <table class="w-full text-body-medium border-collapse">
              <thead>
                <tr class="border-b-2 border-outline-variant/30">
                  <th class="text-left py-3 px-2 font-semibold">Cookie</th>
                  <th class="text-left py-3 px-2 font-semibold">Tipo</th>
                  <th class="text-left py-3 px-2 font-semibold">Finalidad</th>
                  <th class="text-left py-3 px-2 font-semibold">Duración</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-b border-outline-variant/20">
                  <td class="py-3 px-2 font-mono text-body-small">sb-access-token</td>
                  <td class="py-3 px-2">Esencial</td>
                  <td class="py-3 px-2">Token de autenticación de sesión</td>
                  <td class="py-3 px-2">8 horas</td>
                </tr>
                <tr class="border-b border-outline-variant/20">
                  <td class="py-3 px-2 font-mono text-body-small">sb-refresh-token</td>
                  <td class="py-3 px-2">Esencial</td>
                  <td class="py-3 px-2">Renovación automática de la sesión</td>
                  <td class="py-3 px-2">8 horas</td>
                </tr>
                <tr class="border-b border-outline-variant/20">
                  <td class="py-3 px-2 font-mono text-body-small">cookie-consent</td>
                  <td class="py-3 px-2">Esencial</td>
                  <td class="py-3 px-2">Recordar tu preferencia de cookies</td>
                  <td class="py-3 px-2">12 meses</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">3. Cookies esenciales</h2>
          <p>Actualmente, ComandaPlus solo utiliza cookies estrictamente necesarias para el funcionamiento del servicio. Estas cookies no requieren consentimiento previo conforme al artículo 22.2 de la LSSI-CE, pero te informamos de su uso con total transparencia.</p>
          <p>Las cookies de autenticación (<code>sb-access-token</code> y <code>sb-refresh-token</code>) son necesarias para mantener tu sesión iniciada y proteger tu cuenta. Sin ellas, no podrías acceder al panel de gestión.</p>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">4. Cookies de terceros</h2>
          <p>Actualmente no utilizamos cookies de terceros (analítica, publicidad ni redes sociales). Si en el futuro incorporamos alguna, actualizaremos esta política y solicitaremos tu consentimiento previo.</p>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">5. Cómo gestionar las cookies</h2>
          <p>Puedes configurar tu navegador para bloquear o eliminar cookies. Ten en cuenta que si bloqueas las cookies esenciales, no podrás utilizar ComandaPlus correctamente.</p>
          <ul class="list-disc pl-6 space-y-1">
            <li><strong>Chrome:</strong> Configuración → Privacidad y seguridad → Cookies</li>
            <li><strong>Firefox:</strong> Configuración → Privacidad y seguridad → Cookies y datos del sitio</li>
            <li><strong>Safari:</strong> Preferencias → Privacidad → Gestionar datos del sitio web</li>
            <li><strong>Edge:</strong> Configuración → Cookies y permisos del sitio</li>
          </ul>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">6. Contacto</h2>
          <p>Para cualquier consulta sobre nuestra política de cookies, contacta con nosotros en <strong>dieter@comandaplus.com</strong>.</p>
        </section>

        <section>
          <h2 class="text-title-large font-semibold text-on-surface mt-8 mb-3">7. Más información</h2>
          <p>Consulta nuestra <NuxtLink to="/legal/privacidad" class="text-primary hover:underline">Política de Privacidad</NuxtLink> para conocer cómo tratamos tus datos personales.</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: false,
})

useHead({
  title: 'Política de Cookies — ComandaPlus',
})
</script>
